import { defineMessages } from 'react-intl';

export const i18n: {
	markdownSourceWritebackErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	markdownSourceWritebackErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	markdownSourceWritebackErrorTitle: {
		id: 'editor-presets.fullPage.markdownSourceWritebackErrorTitle',
		defaultMessage: 'Changes can’t be saved',
		description:
			'Title for the error flag shown when markdown source edits cannot be applied to the editor document.',
	},
	markdownSourceWritebackErrorDescription: {
		id: 'editor-presets.fullPage.markdownSourceWritebackErrorDescription',
		defaultMessage: 'Something went wrong while saving your changes. Try reloading the page.',
		description:
			'Description for the error flag shown when markdown source edits cannot be applied to the editor document.',
	},
});
